import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionOriginalEquityLessThen extends AbstractConditionDescriptionComponent {

    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionOriginalEquityLessThen, require('./ConditionOriginalEquityLessThen.html'))
}